export default __webpack_public_path__ + "static/accept-efcb0e668d66864b8fc70c8a09474fe0.png";